import { getJSONfromDOM } from '@pixelcabin/ui-utils';

import { PRODUCT_TYPE } from './const';

import { getCostPerItemDataFromTags } from './cost_per_item';

export const prepareInitialData = () => {
  const initialData = getJSONfromDOM(['#pxl-purchase-form-data']);

  const {
    subscribe,
    upSell,
    freeGift,
    quantitySelector: quantitySelectorRaw,
    tags,
    sellingPlanGroups,
    variants: rawVariants,
    translations
  } = initialData;

  const quantitySelector = ((quantitySelector, tags) => {
    if (!quantitySelector || quantitySelector.type !== 'dropdown') {
      return quantitySelector;
    }

    const { itemType, multiplier, translationKey } = getCostPerItemDataFromTags(
      tags
    );

    const { textSingularRaw, textPluralRaw } = translations.quantitySelector[
      translationKey
    ];

    return {
      ...quantitySelector,
      itemType,
      multiplier,
      textSingularRaw,
      textPluralRaw,
      translationKey
    };
  })(quantitySelectorRaw, tags);

  if (subscribe && subscribe.shippingIntervalFrequency) {
    subscribe.shippingIntervals = subscribe.shippingIntervalFrequency.split(
      ','
    );

    subscribe.options = subscribe.shippingIntervals.map(interval => {
      return {
        label: interval + ' ' + subscribe.shippingIntervalUnitType,
        value: interval.toString()
      };
    });
  }

  if (upSell) {
    const defaultQuantity = 10;
    let options = [];

    if (upSell.inventoryQuantity > 0) {
      // values from 1 to 10 if inventory allows
      options = [
        ...Array(Math.min(defaultQuantity, upSell.inventoryQuantity))
      ].map((_, i) => ({
        label: upSell.dropdown.option.replace('%AMOUNT%', i + 1),
        value: i + 1
      }));
    }

    // bigger, bundle values
    [15, 20, 25, 30, 50].forEach(value => {
      if (upSell.inventoryQuantity >= value) {
        options.push({
          label: upSell.dropdown.option.replace('%AMOUNT%', value),
          value
        });
      }
    });

    options.unshift({
      label: upSell.dropdown.placeholder,
      value: 0
    });

    upSell.options = options;
  }

  if (freeGift) {
    freeGift.collection = freeGift.collection.filter(gift => gift.id);

    freeGift.options = freeGift.collection.map(item => {
      return {
        label: item.title,
        value: item.id
      };
    });
  }

  const selectedSubscriptionFrequency = (subscribe => {
    if (__SHOPIFY_SUBSCRIPTIONS__) {
      return null;
    }

    return subscribe && subscribe.shippingIntervals
      ? subscribe.shippingIntervals[0]
      : null;
  })(subscribe);

  const [sellingPlans, selectedSellingPlan] = (sellingPlanGroups => {
    if (!__SHOPIFY_SUBSCRIPTIONS__ || sellingPlanGroups.length === 0) {
      return [null, null];
    }

    // Shopify lets you attribute multiple groups to a same product,
    // but Recharge's interface doesn't, so we take the first sellingPlanGroup
    const { selling_plans: sellingPlans } = sellingPlanGroups[0];

    return [sellingPlans, sellingPlans[0]];
  })(sellingPlanGroups);

  const selectedProductType = initialData.showPurchaseOptions
    ? null
    : PRODUCT_TYPE.ONETIME;

  const variants = rawVariants.map(variant => {
    if (
      variant.subscriptionVariantId &&
      variant.subscriptionVariantId.length > 0
    ) {
      variant.subscriptionVariantId = Number.parseInt(
        variant.subscriptionVariantId
      );

      variant.discountVariantPrice = Number.parseInt(
        variant.discountVariantPrice
      );
    }

    return variant;
  });

  const selectedVariant = variants.length > 0 ? variants[0] : null;

  const shouldShowFreeGiftDropdown =
    initialData.freeGift && initialData.freeGift.collection ? true : false;

  const selectedFreeGift =
    initialData.freeGift && initialData.freeGift.collection
      ? initialData.freeGift.collection[0]
      : null;

  return {
    ...initialData,
    variants,
    quantitySelector,
    subscribe,
    freeGift,
    upSell,
    selectedProductType,
    hasNotEnoughStock: false,
    quantity: 1,
    selectedFreeGift,
    selectedSubscriptionFrequency,
    selectedUpsellProductQuantity: 0,
    selectedVariant,
    shouldShowFreeGiftDropdown,
    selectedSellingPlan,
    sellingPlans
  };
};
